import React from 'react';
import { INSTAGRAM_LINK } from '../../constants';
import { InstagramIcon } from '../icons';

// Site footer: copyright + external Instagram link. Present on all in-app routes.
export const Footer = () => (
    <footer className="flex items-center justify-between border-t border-tone-150 px-8 py-4 text-eyebrow font-light uppercase tracking-footer text-tone-800">
        <span>© Dragan Strukelj — All artwork</span>
        <a
            href={INSTAGRAM_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-tone-900 hover:text-black"
        >
            <span className="border-b border-tone-300 pb-px">Instagram</span>
            <InstagramIcon size={15} className="text-tone-600" />
        </a>
    </footer>
);
